import LogoMark from "@/components/LogoMark";
import { PHONE_TEL } from "@/lib/site";
import { Phone } from "lucide-react";

const NAV = [
  { label: "Servizi", href: "#servizi" },
  { label: "Emergenza", href: "#emergenza" },
  { label: "Come funziona", href: "#come-funziona" },
  { label: "Copertura", href: "#copertura" },
  { label: "Contatti", href: "#contatti" },
];

export default function Footer() {
  return (
    <footer className="border-t border-line bg-ink/50">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-14 sm:px-6 md:grid-cols-[1.2fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-3">
            <LogoMark size={38} />
            <span className="font-display text-lg font-extrabold tracking-tight text-white">
              Roma<span className="text-volt">Tech24</span>
            </span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
            Pronto intervento h24 e riparazioni in urgenza a Roma e Provincia:
            elettrico, serrature e automazioni per cancelli.
          </p>
        </div>

        <nav aria-label="Footer">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
            Naviga
          </p>
          <ul className="mt-4 space-y-2.5">
            {NAV.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  className="text-sm text-slate-300 transition-colors hover:text-volt"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
            Emergenze 24/7
          </p>
          <a
            href={PHONE_TEL}
            data-testid="footer-phone-button"
            className="mt-4 flex items-center gap-2.5 font-display text-xl font-extrabold text-volt transition-colors hover:text-volthi"
          >
            <Phone size={19} strokeWidth={2.5} />
            06 85902421
          </a>
          <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.18em] text-slate-500">
            Chiamata diretta · nessun costo aggiuntivo
          </p>
          <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.18em] text-slate-500">
            Roma e Provincia · tutti i giorni
          </p>
        </div>
      </div>

      <div className="border-t border-line py-6">
        <p className="mx-auto max-w-7xl px-4 text-center font-mono text-[11px] uppercase tracking-[0.18em] text-mist/60 sm:px-6">
          © {new Date().getFullYear()} RomaTech24 · P.IVA 65917418001 · Pronto intervento elettrico, serrature, automazioni
        </p>
      </div>
    </footer>
  );
}
